require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-j-8-a-oq.json") })
        }
      }, "path---photos-professional-j-8-a-oq");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-j-8-a-oq!./.cache/json/photos-professional-j-8-a-oq.json
// module id = 786
// module chunks = 231608221292675